/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const NoticeInfo = createSvgIcon(
    <>
        <path d="M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20z" />
        <path
            d="M20 14.84c1.108 0 2-.844 2-1.905 0-1.06-.892-1.879-2-1.879-1.084 0-2 .82-2 1.88s.916 1.903 2 1.903zm-1.566 13.228h3.156V16.839h-3.156v11.229z"
            fill="#fff"
        />
    </>,
    "NoticeInfo",
);

export default NoticeInfo;
